import React from 'react';
import { useSelector } from 'react-redux';

import { SkeletonText, SkeletonTable } from 'ui/components/skeleton';

export const SectionUnit = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Product.Show']
  );

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3 z-3">
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Unit'
        )}
      </div>

      <div className="pt-2">
        {StateLoading ? (
          <SkeletonTable headerCount={4} bodyCount={2} />
        ) : (
          <div className="table-responsive">
            <table
              width="100%"
              className="table table-hover table-vcenter card-table datatable border"
            >
              <thead className="bg-light">
                <tr className="th">
                  <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                    Unit
                  </td>
                </tr>
              </thead>
              <tbody>
                {data?.map((d, i) => (
                  <tr key={i}>
                    <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                      {d?.unit}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};
